var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1357 293L1357 321",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1357.5,
    cy: 288.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.99 288.19C1352.99 284.283 1356.29 281.117 1360.36 281.117C1360.94 281.117 1361.51 281.184 1362.06 281.308C1360.74 280.48 1359.19 280 1357.52 280C1352.81 280 1349 283.806 1349 288.5C1349 293.194 1352.81 297 1357.52 297C1359.81 297 1361.89 296.093 1363.43 294.62C1362.49 295.032 1361.45 295.263 1360.36 295.263C1356.29 295.263 1352.99 292.096 1352.99 288.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1366.4 287.6L1366.37 285.146L1364.54 286.719L1362.3 286.056L1363.11 288.337L1361.77 290.381L1364.1 290.218L1365.5 292.144L1366.13 289.763L1368.34 288.909L1366.4 287.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.4698c74ff5cabdf6338a0f2ff6edf9a5.svg";
export { ForwardRef as ReactComponent };